import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import moment from "moment";

const DateSelectionModal = ({ isOpen, onClose, onConfirm, selectedDate, existingType }) => {
  const [selectionType, setSelectionType] = useState("");

  useEffect(() => {
    if (isOpen) {
      setSelectionType(existingType || "valarpirai");
    }
  }, [isOpen, existingType]);

  const handleConfirm = () => {
    onConfirm(selectedDate, selectionType);
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        style: {
          borderRadius: "15px",
          padding: "10px",
        }
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
            Confirm Date Selection
          </Typography>
          <IconButton onClick={onClose} size="small">
            <IoClose />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3, mt: 1 }}>
          <Typography variant="body1" gutterBottom>
            Selected Date:
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#e83e8c", bgcolor: "#fce4ec", p: 1, borderRadius: "8px", textAlign: "center" }}>
            {selectedDate ? moment(selectedDate).format("DD MMMM YYYY") : ""}
          </Typography>
        </Box>

        <FormControl component="fieldset" fullWidth>
          <FormLabel component="legend" sx={{ mb: 1, fontWeight: "500" }}>Choose Category:</FormLabel>
          <RadioGroup
            value={selectionType}
            onChange={(e) => setSelectionType(e.target.value)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Box
              sx={{
                border: '1px solid',
                borderColor: selectionType === 'valarpirai' ? '#9c27b0' : '#ddd',
                borderRadius: '8px',
                bgcolor: selectionType === 'valarpirai' ? '#f3e5f5' : 'transparent',
                p: 0.5,
                px: 2
              }}
            >
              <FormControlLabel 
                value="valarpirai" 
                control={<Radio sx={{ color: '#9c27b0', '&.Mui-checked': { color: '#9c27b0' } }} />} 
                label="Valarpirai Date" 
              />
            </Box>
            <Box
              sx={{
                border: '1px solid',
                borderColor: selectionType === 'theipirai' ? '#2196f3' : '#ddd',
                borderRadius: '8px',
                bgcolor: selectionType === 'theipirai' ? '#e3f2fd' : 'transparent',
                p: 0.5,
                px: 2
              }}
            >
              <FormControlLabel value="theipirai" control={<Radio color="primary" />} label="Theipirai Date" />
            </Box>
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: "#666", textTransform: "none" }}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            px: 4,
            boxShadow: "none",
            backgroundColor: "#e83e8c",
            "&:hover": {
              backgroundColor: "#d81b60"
            }
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DateSelectionModal;
